var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ticketDetails" } },
    [
      _c(
        "div",
        { ref: "scrollArea", staticClass: "section-content" },
        [
          _vm.selected
            ? [
                _c("div", { staticClass: "vo-card" }, [
                  _c("div", { staticClass: "vo-header" }, [
                    _vm._v("\n          User Details\n          ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vo-content" }, [
                    _c(
                      "div",
                      { staticClass: "avatar" },
                      [
                        _c("vo-avatar", {
                          attrs: { user: _vm.selected, size: 44 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [_vm._v("Name")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.selected.fullName))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("Joined Date")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(_vm._f("dateShorthand")(_vm.selected.joined))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("Email Address")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.selected.email))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vo-s-list" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v("Phone Number")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.selected.phone))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clear" })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vo-card" },
                  [
                    _c("div", { staticClass: "vo-header" }, [
                      _vm._v("\n          Roles\n          "),
                      _c(
                        "div",
                        { staticClass: "vo-actions" },
                        [
                          _vm.hasPermissions(["role"])
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "icon-button",
                                  attrs: { small: "", fab: "", flat: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.routeAddQuery("dialog", "role-manage")
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { medium: "" } }, [
                                    _vm._v("mdi-plus")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.selected.roles, function(role, i) {
                      return _c("div", { key: i, staticClass: "role" }, [
                        _c("div", { staticClass: "left" }, [
                          _c("div", { staticClass: "title-value" }, [
                            _vm._v(_vm._s(_vm.$store.getters.role(role).title))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "role-details",
                              class: {
                                has: _vm.$store.getters.role(role).property,
                                selectable:
                                  _vm.$store.getters.role(role).property &&
                                  _vm.hasPermissions(["property"])
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.openProperty(
                                        _vm.$store.getters.role(role)
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.getters.role(role).property
                                        ? _vm.$store.getters.property(
                                            _vm.$store.getters.role(role)
                                              .property
                                          ).name
                                        : "All Properties"
                                    )
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "role-details",
                              class: {
                                has: _vm.$store.getters.role(role).unit,
                                selectable:
                                  _vm.$store.getters.role(role).unit &&
                                  _vm.hasPermissionsInProperty(
                                    ["unit"],
                                    _vm.$store.getters.role(role).property
                                  )
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.openUnit(
                                        _vm.$store.getters.role(role)
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.getters.role(role).unit
                                        ? _vm.$store.getters.unit(
                                            _vm.$store.getters.role(role).unit
                                          ).title
                                        : "All Units"
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.hasPermissions(["role"])
                          ? _c(
                              "div",
                              { staticClass: "right" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "vo-icon-button",
                                    attrs: { small: "", fab: "", flat: "" },
                                    on: {
                                      click: function($event) {
                                        _vm.routeAddQueries({
                                          dialog: "role-manage",
                                          dialogAction: "edit",
                                          dialogItem: role
                                        })
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { medium: "" } }, [
                                      _vm._v("mdi-pencil")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "vo-icon-button delete",
                                    attrs: { small: "", fab: "", flat: "" },
                                    on: {
                                      click: function($event) {
                                        _vm.removeRoleDialog(role)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { medium: "" } }, [
                                      _vm._v("mdi-delete")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    }),
                    _vm._v(" "),
                    _c("vo-list-footer", {
                      attrs: {
                        list: { items: _vm.selected.roles, name: "Roles" }
                      }
                    })
                  ],
                  2
                )
              ]
            : [_c("vo-empty-state", { attrs: { text: "SELECT A PERSON" } })]
        ],
        2
      ),
      _vm._v(" "),
      _c("vo-details-header")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42f39b33", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f39b33","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PeopleDetails.vue
// module id = 533
// module chunks = 4